export const AutoSignSetupStatus = {
  Failed: 'failed',
  Pending: 'pending',
  Loading: 'loading',
  Complete: 'complete'
} as const

export type AutoSignSetupStatus =
  (typeof AutoSignSetupStatus)[keyof typeof AutoSignSetupStatus]

export type AutoSignSetupState = {
  account: AutoSignSetupStatus
  authorization: AutoSignSetupStatus
}
